import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from '@env/environment';
import { AppModule } from './app/app.module';

import { preloaderFinished } from '@shared/utils/preloader.util';
preloaderFinished();

if (environment.production) {
  enableProdMode();
}


if (environment.playground) {
  const announceKitScript = document.createElement('script');

  announceKitScript.type = 'text/javascript';
  announceKitScript.text = `
  window.announcekit = (window.announcekit || { queue: [], on: function(n, x) { window.announcekit.queue.push([n, x]); }, push: function(x) { window.announcekit.queue.push(x); } });
  window.announcekit.push({
    widget: "https://changelog.dashboard.qa/widgets/v2/1U7SBa",
    selector: ".announcekit-widget",
    badge: {
      style: {
        position: "absolute",
        fontSize: "10px"
      }
    }
  })
  `;
  document.body.appendChild(announceKitScript);

  const announceKitLib = document.createElement('script');

  announceKitLib.src = 'https://cdn.announcekit.app/widget-v2.js';
  announceKitLib.async = true;

  document.body.appendChild(announceKitLib);

  const googleAuthLib = document.createElement('script');

  googleAuthLib.src = 'https://apis.google.com/js/api.js';
  googleAuthLib.async = true;
  googleAuthLib.defer = true;

  document.body.appendChild(googleAuthLib);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(res => {
    if ((window as any).appBootstrap) {
      (window as any).appBootstrap();
    }
    return res;
  })
  .catch(err => console.log(err));
